"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetFilterValidator = exports.widgetFilterGroupsValidator = exports.filterValidator = exports.roundingOpts = exports.DEFAULT_ROUNDING_OPTS = exports.commonTypeSchemaValidator = exports.DateAllowedFilterComparisons = exports.NumberAllowedFilterComparisons = exports.StringAllowedFilterComparisons = exports.FilterComparisonType = void 0;
const zod_1 = require("zod");
const datasource_1 = require("../../datasource");
var FilterComparisonType;
(function (FilterComparisonType) {
    FilterComparisonType["CT"] = "contains";
    FilterComparisonType["NCT"] = "..";
    FilterComparisonType["EQ"] = "==";
    FilterComparisonType["GT"] = ">";
    FilterComparisonType["LT"] = "<";
    FilterComparisonType["GTE"] = ">=";
    FilterComparisonType["LTE"] = "<=";
    FilterComparisonType["NEQ"] = "!=";
    FilterComparisonType["IN"] = "in";
    FilterComparisonType["NOT_IN"] = "not in";
})(FilterComparisonType = exports.FilterComparisonType || (exports.FilterComparisonType = {}));
exports.StringAllowedFilterComparisons = new Set([
    FilterComparisonType.CT,
    FilterComparisonType.NCT,
    FilterComparisonType.EQ,
    FilterComparisonType.NEQ,
    FilterComparisonType.IN,
    FilterComparisonType.NOT_IN,
]);
exports.NumberAllowedFilterComparisons = new Set([
    FilterComparisonType.EQ,
    FilterComparisonType.NEQ,
    FilterComparisonType.GT,
    FilterComparisonType.GTE,
    FilterComparisonType.LT,
    FilterComparisonType.LTE,
    FilterComparisonType.NOT_IN,
]);
exports.DateAllowedFilterComparisons = exports.NumberAllowedFilterComparisons;
exports.commonTypeSchemaValidator = zod_1.z
    .object({
    tab_id: zod_1.z.number().int().min(0),
    creditor_column_id: zod_1.z.string().optional(),
    skip_row_level_security: zod_1.z.boolean().optional(),
})
    .refine(({ skip_row_level_security, creditor_column_id }) => {
    if (!skip_row_level_security && !creditor_column_id)
        return false;
    return true;
}, 'Coluna do usuário é obrigatória');
exports.DEFAULT_ROUNDING_OPTS = {
    round_mode: 'down',
    decimal_places: 2,
};
exports.roundingOpts = zod_1.z.object({
    round_mode: zod_1.z
        .union([zod_1.z.literal('up'), zod_1.z.literal('down')])
        .default(exports.DEFAULT_ROUNDING_OPTS.round_mode),
    decimal_places: zod_1.z.number().gte(0).default(exports.DEFAULT_ROUNDING_OPTS.decimal_places),
});
exports.filterValidator = zod_1.z.object({
    column: zod_1.z.string(),
    comparison: zod_1.z.nativeEnum(FilterComparisonType),
    expression: zod_1.z.string(),
});
exports.widgetFilterGroupsValidator = zod_1.z.object({
    filter_type: zod_1.z.nativeEnum(datasource_1.FilterType),
    filters: zod_1.z.array(exports.filterValidator),
});
exports.widgetFilterValidator = zod_1.z
    .object({
    groups: zod_1.z.array(exports.widgetFilterGroupsValidator),
    filter_type: zod_1.z.nativeEnum(datasource_1.FilterType),
})
    .optional();
